<template>
  <div class="container">
    <div class="up">
      <div class="left">
        <h3 class="title">Order Details</h3>
        <div class="item">
          <div class="label">Order No.:</div>
          <div class="text">{{ detail.order_no }}</div>
        </div>
        <div class="item">
          <div class="label">Order Time:</div>
          <div class="text">{{ detail.submit_time }}</div>
        </div>
        <div class="item">
          <div class="label">Delivery Info:</div>
          <div class="text">
            {{ detail.contact_person }}，{{ detail.contact_mobile }},
            {{ detail.address }} ,{{detail.city}},{{ detail.province }},{{ detail.zone }}
          </div>
        </div>
        <div class="item" v-if="detail.need_sample > 0">
          <div class="label">Fabric Sample:</div>
          <div class="text">
            Sample Required <span @click="show_sample_detail = true">View Details</span>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="title">
          Order Status: <span class="status" :class="oc(detail)">{{
            detail.status_name
          }}</span>
        </div>
        <div class="item">
          <div class="label">Order Amount:</div>
          <div class="text">
            <span class="money">${{ detail.total_price }}</span>
            (Including shipping $0)
          </div>
        </div>
      </div>
      <template v-for="(v,k) in detail.mtms">
        <div class="self" v-show="detail.is_need_send_back">
          <template v-if="!detail.self_send">
            <p class="tip">
              *You have chosen to provide your own fabric. Please fill in the fabric size and quantity details for later verification, and mail the relevant fabric to the manufacturer according to the shipping address below.
            </p>
            <div class="table">
              <table>
                <thead>
                <tr>
                  <th></th>
                  <th>Fabric Information</th>
                  <th>Width/Weight</th>
                  <th>Composition</th>
                  <th>Note</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in v.design_data.category.material_self" :key="index">
                  <td>{{ item.alias }}</td>
                  <td>
                    <div class="material-info">
                      <img :src="item.image" alt="" class="image" />
                      <div class="name">{{ item.fabric_name_cn }}</div>
                    </div>
                  </td>
                  <td>{{ item.width_wide }}</td>
                  <td>{{ item.component }}</td>
                  <td>{{ item.desc }}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <table>
              <thead>
              <tr>
                <th></th>
                <th>Accessory Information</th>
                <th>Unit</th>
                <th>Quantity</th>
                <th>Note</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in v.design_data.category.accessory_self" :key="index">
                <td>{{ item.alias }}</td>
                <td>
                  <div class="material-info">
                    <img :src="item.image" alt="" class="image" />
                    <div class="name">{{ item.accessory_name }}</div>
                  </div>
                </td>
                <td>{{ item.measure_unit_en }}</td>
                <td>{{ item.num }}</td>
                <td>{{ item.desc }}</td>
              </tr>
              </tbody>
            </table>
            <div class="tip2">
              <div class="tt">
                *You have chosen to provide your own fabric. Please fill in the fabric size and quantity details for later verification, and mail the relevant fabric to the manufacturer according to the shipping address below.
              </div>
              <div class="btn-print" @click="go2fabric">Print Fabric Details</div>
            </div>
            <div class="back-info">
              <div class="left">
                <p>Recipient: {{ setting.contact_person }}</p>
                <p>Phone: {{ setting.contact_mobile }}</p>
                <p>Shipping Address: {{ setting.contact_address }}</p>
              </div>
              <div class="btn-fill" @click="go2fill">Fill in Shipping Tracking Number</div>
            </div>
          </template>
          <template v-else>
            <div
                    class="back-info"
                    style="background: white; border: 1px solid #e2e5e9"
            >
              <img
                      src="../../assets/images/pay-success.png"
                      alt=""
                      class="icon"
              />
              <div class="left" style="border: none">
                <p v-if="detail.ops.status === 0">Shipped, Logistics Order Created</p>
                <p v-else>Materials Confirmed Received</p>
                <p>Logistics Company: {{ detail.ops.logistics_name }}</p>
                <p>Tracking Number: {{ detail.ops.logistics_no }}</p>
              </div>
            </div>
          </template>
        </div>
      </template>
    </div>

    <popup
      :show.sync="is_popup_show"
      width="490px"
      height="320px"
      @on-close="close"
    >
      <h2>Fill in Tracking Number</h2>
      <div class="form">
        <div class="form-group">
          <div class="form-label">Courier Name:</div>
          <div class="form-control">
            <select
              class="input"
              placeholder="Please enter courier name"
              v-model="form_data.logistics_name"
            >
              <option value="">Please Select</option>
              <option value="SF Express">SF Express</option>
              <option value="JD Express">JD Express</option>
              <option value="STO Express">STO Express</option>
              <option value="YTO Express">YTO Express</option>
              <option value="Yunda Express">Yunda Express</option>
              <option value="DBL Express">DBL Express</option>
              <option value="ZTO Express">ZTO Express</option>
              <option value="Postal EMS">Postal EMS</option>
              <option value="J&T Express">J&T Express</option>
              <option value="Best Express">Best Express</option>
              <option value="UC Express">UC Express</option>
              <option value="AAE Global">AAE Global</option>
              <option value="ANE Logistics">ANE Logistics</option>
              <option value="Other">Other</option>
            </select>
          </div>
        </div>
        <div class="form-group">
          <div class="form-label">Tracking Number:</div>
          <div class="form-control">
            <input
              type="text"
              class="input"
              placeholder="Please enter tracking number"
              v-model="form_data.logistics_no"
            />
          </div>
        </div>
        <div class="btn-submit" @click="save">Save</div>
      </div>
    </popup>

    <div class="bottom">
      <table border="1">
        <thead>
          <tr>
            <th>Product Information</th>
            <th>Style Category</th>
            <th>Size</th>
            <th>Quantity</th>
          </tr>
        </thead>
        <tbody>
        <tr v-for="(v,k) in detail.mtms" @click="go2modify(v.uuid)">
            <td>
              <div class="product-info cursor" >
                <img :src="v.design_data.category.image" alt="" class="image" />
                <div class="product-name">{{ v.design_data.category.style_no }}</div>
                <div class="style-info" @click.stop="go2summary(v.id)">style info</div>
              </div>
            </td>
            <td>{{ v.design_data.category.product_category_name }}</td>
            <td>{{ v.spec_info.join(";") }}</td>
            <td>x{{ v.quantity }}</td>
          </tr>
        </tbody>
      </table>

      <div class="price-wrap">
        <div class="item" v-for="(vv, kk) in detail.cost">
          <div class="label">{{ vv.title }}</div>
          <div class="text">${{ vv.amount }}</div>
        </div>
        <div class="item">
          <div class="label">Amount Paid:</div>
          <div class="text">
            <span class="money">${{ detail.total_price }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- Sample Details -->
    <Popup :show.sync="show_sample_detail" width="998px" height="750px">
      <div class="sample">
        <div class="sample-title">Sample Details</div>
        <table>
          <thead>
            <tr>
              <!-- <th></th> -->
              <th>Product Information</th>
              <th>Color</th>
              <th>Composition</th>
              <th>Width/Weight</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, index) in detail.order_material">
              <tr class="tr-no-td">
                <td colspan="4">
                  <div class="logistics">
                    <div class="company-no">
                      <span
                        >Logistics Info:{{
                          item[0].logistics_name || "No logistics info yet, please wait"
                        }}</span
                      >
                      <span v-if="item[0].logistics_no"
                        >Tracking No.:{{ item[0].logistics_no }}</span
                      >
                      <span
                        v-if="item[0].logistics_no"
                        class="btn"
                        @click="onCopyLogistics(item.logistics_no[0])"
                        >Copy Number</span
                      >
                    </div>
                    <!-- <div v-if="item[0].logistics_name && item[0].logistics_no" class="logistics-time">Shipping Time:{{item[0].create_time}}</div> -->
                  </div>
                </td>
              </tr>
              <tr class="tr-td" v-for="val in item" :key="`vi${val.id}`">
                <!-- <td>Fabric A</td> -->
                <td>
                  <div class="main-info">
                    <img
                      :src="val.fabric_image | default_img"
                      alt=""
                      class="images"
                    />
                    <div class="name-code">
                      <span>Name:{{ val.fabric_name }}</span>
                      <span>Code:{{ val.fabric_key }}</span>
                    </div>
                  </div>
                </td>
                <td>{{ val.color_name }}</td>
                <td>{{ val.fabric.component }}</td>
                <td>
                  {{ val.fabric.width_wide }} <br />
                  {{ val.fabric.weight }}
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </Popup>
  </div>
</template>

<script>
import { OrderDetail, Profile, SendFabric } from "@/api/index.js";
import Popup from "@/components/Popup.vue";
import { mapState } from "vuex";
export default {
  name: "OrderDetail",
  components: {
    Popup,
  },
  data() {
    return {
      uuid: 0,
      detail: {
        cost: [],
        spec_info: [],
        design: {},
      },
      is_popup_show: false,
      form_data: {
        logistics_name: "",
        logistics_no: "",
      },
      show_sample_detail: false,
    };
  },
  watch: {},
  computed: {
    ...mapState(["setting"]),
  },
  mounted() {
    this.uuid = this.$route.query.uuid;
    this.getDetail();
  },
  methods: {
    go2summary(id) {
      let route = this.$router.resolve({name: 'WorkBenchSummaryOuter', query: {uuid: id, from: 'detail'}})
      window.open(route.href, '_blank')
    },
    go2modify(uuid) {
      if(this.detail.scene === 'fast') {
        this.$router.push({name: 'ModifyDesign', query: {uuid}})
      }
    },
    async onCopyLogistics(logistics_no) {
      if (!logistics_no) return;
      await navigator.clipboard.writeText(logistics_no);
      this.$layer.msg("Copied successfully");
    },
    close() {},
    save() {
      SendFabric({ ...this.form_data, uuid: this.detail.uuid })
        .then(() => {
          this.$layer.msg(`Saved successfully`);
          this.is_popup_show = false;
        })
        .catch((res) => {
          this.$layer.msg(res.msg);
        })
        .finally(() => {
          this.getDetail();
        });
    },
    go2fill() {
      this.is_popup_show = true;
    },
    go2fabric() {
      this.$router.push({
        name: "FabricDetail",
        query: { uuid: this.detail.uuid },
      });
    },
    oc(v) {
      return [v.status_text];
    },
    async getProfile() {
      return Profile().then((response) => {
        return response;
      });
    },
    async getDetail() {
      return OrderDetail({ uuid: this.uuid })
        .then((response) => {
          this.detail = response.data;
        })
        .catch((err) => {
          this.$layer.msg(err.msg);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0 70px 100px 30px;
  background: #f6f7fa;

  .up {
    padding: 36px 0;
    border-radius: 10px;
    background: white;
    display: flex;
    flex-wrap: wrap;
    .left {
      padding-left: 30px;
      width: 650px;
      border-right: 1px solid #e6e6e6;
      .title {
        color: #333333;
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 30px;
      }
      .item {
        margin: 10px 0;
        font-size: 12px;
        display: flex;
        flex-wrap: nowrap;
        .label {
          width: 60px;
          color: #191a1c;
        }
        .text {
          color: #666666;
          span {
            color: #5e8fc7;
            text-decoration: underline;
            cursor: pointer;
          }
        }
      }
    }
    .right {
      width: 620px;
      padding-left: 30px;
      .title {
        color: #333333;
        font-size: 16px;
        margin-bottom: 25px;
        .status {
          font-size: 20px;
          font-weight: bold;
          &.unpaid {
            color: #ff4400;
          }
          &.wait_delivery {
            color: #1572b8;
          }
          &.wait_confirm {
            color: #32a410;
          }
          &.cancel {
            color: #666666;
          }
          &.complete {
            color: #666666;
          }
        }
      }
      .item {
        margin: 10px 0;
        font-size: 12px;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        .label {
          width: 60px;
          color: #191a1c;
        }
        .text {
          color: #666666;
          .money {
            font-weight: bold;
            font-size: 16px;
          }
        }
      }
    }

    .self {
      padding: 0 20px;
      .tip {
        font-size: 18px;
        color: #1a1a1a;
        font-weight: bold;
        padding: 40px 0 20px 0;
      }
      .tip2 {
        margin: 12px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .tt {
          font-size: 14px;
          color: #666666;
        }
        .btn-print {
          width: 141px;
          height: 37px;
          line-height: 37px;
          background: white;
          border-radius: 18px;
          border: 1px solid #fa3d5a;
          color: #fa3d5a;
          text-align: center;
          cursor: pointer;
        }
      }
      .back-info {
        background: #f7f7f7;
        height: 150px;
        margin: 12px 0;
        padding: 0 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #4d4d4d;
        font-size: 16px;
        .btn-fill {
          width: 180px;
          height: 45px;
          line-height: 45px;
          background: #fa3d5a;
          border-radius: 5px 5px 5px 5px;
          color: white;
          text-align: center;
          cursor: pointer;
        }
        .icon {
          width: 44px;
          height: 44px;
        }
      }
      table {
        width: 100%;
        border-collapse: collapse;
        font-size: 14px;
        table-layout: auto;
        border: 1px solid #e5e5e5;
        text-align: center;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        margin-bottom: 20px;
        .material-info {
          display: flex;
          align-items: center;
          column-gap: 10px;
          .image {
            width: 68px;
            height: 68px;
            object-fit: contain;
          }
          .product-name {
            color: #191a1c;
            font-size: 14px;
            font-weight: 500;
          }

        }
        thead {
          background: #f6f7fa;
          line-height: 52px;
        }
        th,
        td {
          padding: 8px;
        }
        td {
          border: 1px solid #e5e5e5;
        }
        th:first-child,
        td:first-child {
          padding: 10px;
          width: 100px;
        }
        th:nth-child(2),
        td:nth-child(2) {
          width: 400px;
        }
        th:nth-child(3),
        td:nth-child(3) {
          width: 100px;
        }
        th:nth-child(4),
        td:nth-child(4) {
          width: 200px;
        }

        td:last-child,
        th:last-child {
          width: 300px;
        }
      }
    }
  }

  .bottom {
    margin-top: 10px;
    padding: 36px 30px;
    border-radius: 10px;
    background: white;
    table {
      width: 100%;
      border-collapse: collapse;
      font-size: 14px;
      table-layout: fixed;
      border: 1px solid #e5e5e5;
      text-align: center;
      table-layout: fixed;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      .product-info {
        display: flex;
        align-items: center;
        column-gap: 10px;
        .image {
          width: 68px;
          height: 68px;
        }
        .product-name {
          color: #191a1c;
          font-size: 14px;
          font-weight: 500;
        }
        .style-info {
          color: red;
          font-size: 14px;
          font-weight: 500;
        }
      }
      thead {
        background: #f6f7fa;
        line-height: 52px;
      }
      th,
      td {
        padding: 8px;
      }
      th:first-child,
      td:first-child {
        padding: 10px;
        max-width: 500px;
      }
      th:last-child,
      td:last-child {
        width: 150px;
      }
      td:nth-child(2),
      th:nth-child(2) {
        width: 150px;
      }
      td:nth-child(4),
      th:nth-child(4) {
        width: 150px;
      }
    }

    .price-wrap {
      margin-top: 70px;
      display: flex;
      flex-wrap: wrap;
      .item {
        width: 100%;
        margin: 10px 0;
        font-size: 14px;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: flex-end;
        color: #191a1c;
        .label {
          width: 130px;
          text-align: right;
        }
        .text {
          color: #666666;
          .money {
            font-weight: bold;
            font-size: 16px;
            color: #fa3d5a;
          }
        }
      }
    }
  }
}

::v-deep .popup-modal {
  h2 {
    padding: 10px 20px;
    color: #333333;
    font-size: 18px;
    font-weight: bold;
    border-bottom: 1px solid #f0f0f0;
  }
  .form {
    padding: 10px 0;
    .form-group {
      display: flex;
      flex-wrap: wrap;
      justify-content: left;
      align-items: center;
      margin-top: 20px;
      .form-label {
        width: 100px;
        font-size: 14px;
        color: #696a6a;
        text-align: right;
      }
      .form-control {
        position: relative;
        .input {
          width: 300px;
          height: 48px;
          line-height: 48px;
          border: 1px solid #d9d9d9;
          border-radius: 5px;
          padding: 0 10px;
          outline: none;
          font-size: 14px;
          &[readonly] {
            border: none;
          }
        }
      }
    }

    .btn-submit {
      margin: 40px 0 0 40px;
      width: 110px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #fa3d5a;
      color: white;
      border-radius: 6px;
      cursor: pointer;
    }
  }
  .sample {
    display: flex;
    flex-direction: column;
    padding: 0 40px;
    max-height: 700px;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
    .sample-title {
      color: #333333;
      font-size: 18px;
      font-weight: bold;
      width: 100%;
      text-align: center;
      margin-top: 39px;
    }
    table {
      width: 100%;
      border-collapse: collapse;
      table-layout: fixed;
      margin-top: 26px;
      border: none !important;
      text-align: center;
      thead {
        background: #333333;
        color: #ffffff;
        font-weight: bold;
        font-size: 14px;
        height: 50px;
      }
      tbody {
        border: none !important;
        .tr-no-td {
          background: #efefef;
          width: 100%;
          height: 44px;
          margin-top: 18px !important;
          border: 1px solid #cccccc;
          td {
            padding: 0 20px;
            .logistics {
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 100%;
              .company-no {
                display: flex;
                align-items: center;
                column-gap: 17px;
                .btn {
                  color: #fa3d5a;
                  cursor: pointer;
                }
              }
              .logistics-time {
                color: #666666;
              }
            }
          }
        }
        .tr-td {
          height: 91px;
        }
        td {
          border: 1px solid #cccccc;
          padding: 10px;
        }
        .main-info {
          display: flex;
          align-items: center;
          column-gap: 10px;
          .images {
            width: 60px;
            height: 60px;
            border-radius: 4px;
            border: 1px solid #e3e4e6;
          }
          .name-code {
            display: flex;
            flex-direction: column;
            text-align: left;
          }
        }
      }
      th:first-child,
      td:first-child {
        // width:91px;
        width: 300px;
      }
      th:nth-child(2),
      td:nth-child(2),
      th:nth-child(3),
      td:nth-child(3) {
        width: 160px;
      }
      th:last-child,
      td:last-child {
        width: 130px;
      }
    }
  }
}
</style>
